import React, { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";

const stats = [
  { num: "04", label: "Years of Impact" },
  { num: "100%", label: "Campaign Success Rate" },
  { num: "60+", label: "Big-Ticket Clients" },
  { num: "3", label: "Tiers — Assembly · Local · National" },
];

const About = () => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });

  return (
    <section
      id="about"
      ref={ref}
      data-testid="about-section"
      className="section-gutter py-20 md:py-32 border-t border-black/10"
    >
      <div className="grid grid-cols-12 gap-6 md:gap-10">
        <div className="col-span-12 md:col-span-4">
          <div className="overline text-black/60">Chapter 01 — The House</div>
          <h2 className="font-serif-display text-5xl md:text-6xl lg:text-7xl leading-[0.9] mt-6">
            Four years.
            <br />
            <em>Zero noise.</em>
          </h2>
        </div>

        <div className="col-span-12 md:col-span-7 md:col-start-6">
          <p className="text-lg md:text-xl leading-relaxed text-black/80">
            We are a Public Relations house built on a single discipline:
            <em> engineer the perception that wins.</em> Across four years and three election tiers,
            our craft has remained the same — research first, narrative next, distribution always.
          </p>
          <p className="mt-6 text-base md:text-lg leading-relaxed text-black/70">
            We run integrated campaigns for political parties, institutions and India&apos;s biggest
            corporate names — combining ground intelligence, data analysis, online operations,
            page handling and offline strategy into one editorial command room.
          </p>

          <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-6">
            {stats.map((s, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 24 }}
                animate={inView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.7, delay: 0.12 * i, ease: [0.22, 1, 0.36, 1] }}
                data-testid={`stat-${i}`}
                className="border-t border-black pt-4"
              >
                <div className="stat-num text-5xl md:text-6xl tabular">{s.num}</div>
                <div className="mt-3 text-[0.7rem] uppercase tracking-[0.18em] text-black/60">
                  {s.label}
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
